

export const TYPES = {
    LANGUAGE_TYPE_GO: 'LANGUAGE_TYPE_GO',
};
